import { Theme } from '@opallabs/gem'
import * as styles from './styles'
import { RadioGroupProvider } from './useRadioGroup'

type RadioGroupProps = {
  defaultValue?: string
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  name: string
  theme: Theme
}

export const RadioGroup: React.FC<React.PropsWithChildren<RadioGroupProps>> = ({
  children,
  onChange,
  defaultValue,
  name,
  theme,
}) => {
  return (
    <RadioGroupProvider
      defaultValue={defaultValue}
      name={name}
      onChange={onChange}
      theme={theme}
    >
      <fieldset
        css={styles.group}
        className="lapidary-radio-group"
        role="radiogroup"
      >
        {children}
      </fieldset>
    </RadioGroupProvider>
  )
}
RadioGroup.displayName = 'Lapidary: Radio.Group'
